export default __webpack_public_path__ + "static/media/IMG_5045.c7c5adb8.png";